import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import * as $ from 'jquery';
import { lang } from 'moment';
import 'src/assets/js/jquery-albe-timeline/jquery-albe-timeline.js';

@Component({
  selector: 'egi-timeline',
  templateUrl: './egi-timeline.component.html',
  styleUrls: ['./egi-timeline.component.css'],
})
export class EgiTimelineComponent implements OnInit {
  @Input() events: EgiTimelineItem[] = [];
  @Output() itemClicked = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.initTimeline();
    this.setupIntersectionObserver();
  }

  initTimeline(): void {
    (<any>$('#timeline')).albeTimeline(this.events, {
      effect: 'zoomInUp',
      showMenu: true,
      language: 'en-US',
    });

    $('#timeline').on('click', '.timeline-event', (event) => {
      const eventData = $(event.currentTarget).data('timeline-event');
      this.itemClicked.emit(eventData);
    });
  }

  setupIntersectionObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const placeholder = entry.target;
          const iframe = document.createElement('iframe');
          iframe.src = placeholder.getAttribute('data-src');
          const style = placeholder.getAttribute('data-style');
          if (style) {
            iframe.style.cssText = style;
          } else {
            iframe.width = '100%';
            iframe.height = '200px';
          }
          placeholder.replaceWith(iframe);
          observer.unobserve(placeholder);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.iframe-placeholder').forEach((placeholder) => {
      observer.observe(placeholder);
    });
  }
}
